import { Button, FormControl, FormLabel, Input, Stack } from "@chakra-ui/react";
import React, { useState } from "react";
import { registerPhoneNumber } from "../../api/authService";
import useCustomToast from "../../customHooks/useCustomToast";

const LoginPhoneNumber = ({ phoneNumber, handlePhoneChange, setSentOTP }) => {
  const [loading, setLoading] = useState(false);
  const showToast = useCustomToast();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const phoneNumber = e.target.elements["phoneNumber"].value;
    if (phoneNumber.length < 10) {
      showToast(
        "Invalid Phone Number",
        "error",
        "Phone number consists of exactly 10 digits."
      );
      return;
    }

    setLoading(true);

    try {
      const data = await registerPhoneNumber(phoneNumber);
      showToast(data[0].message, "success", data[0].data);
      setLoading(false);
      setSentOTP(true);
    } catch (error) {
      showToast(error.message, "error");
      setLoading(false);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Stack spacing={8}>
          <FormControl isRequired>
            <FormLabel htmlFor="phone">Phone Number</FormLabel>
            <Input
              id="phone"
              type="tel"
              placeholder="Enter your phone number"
              name="phoneNumber"
              value={phoneNumber}
              onChange={handlePhoneChange}
              maxLength={10}
              focusBorderColor="teal.500"
            />
          </FormControl>

          <Button
            type="submit"
            colorScheme="teal"
            isLoading={loading}
            loadingText="Sending OTP"
            size="md"
            px={10}
            width={{ base: "full", sm: "auto" }}
            alignSelf="center"
          >
            Send OTP
          </Button>
        </Stack>
      </form>
    </>
  );
};

export default LoginPhoneNumber;
